import {
  FETCH_BUILDING_BY_ID_ERROR,
  FETCH_BUILDING_BY_ID_LOADING,
  FETCH_BUILDING_BY_ID_SUCCESS,
  FETCH_BUILDING_ERROR,
  FETCH_BUILDING_LOADING,
  FETCH_BUILDING_SUCCESS,
  UPDATE_BUILDING_ERROR,
  UPDATE_BUILDING_LOADING,
  UPDATE_BUILDING_SUCCESS
} from '../Types/floorTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {},
  itemLoading: false,
  itemError: null,
  updateLoading: false,
  updateError: null
};

const BuildinReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_BUILDING_LOADING:
      return {
        ...state,
        loading: true,
        data: []
      };

    case FETCH_BUILDING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };

    case FETCH_BUILDING_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };
    case FETCH_BUILDING_BY_ID_LOADING:
      return {
        ...state,
        itemLoading: true,
        itemError: null,
        item: {}
      };
    case FETCH_BUILDING_BY_ID_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        itemError: null,
        item: action.payload
      };
    case FETCH_BUILDING_BY_ID_ERROR:
      return {
        ...state,
        itemLoading: false,
        itemError: action.payload,
        item: {}
      };
    case UPDATE_BUILDING_LOADING:
      return {
        ...state,
        updateLoading: true,
        updateError: null
      };
    case UPDATE_BUILDING_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateError: null,
        data: state.data.map(building =>
          building._id === action.payload._id ? action.payload : building
        )
      };
    case UPDATE_BUILDING_ERROR:
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload
      };

    default:
      return { ...state };
  }
};

export default BuildinReducer;
